import React from 'react';
import { Card } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import PropTypes from 'prop-types';

const PageHeader = ({ type, name }) => {
 return (
  <Card className="mb-1 ">
   <Card.Body className="d-flex gap-2 flex-wrap flex-between-center">
    <div>
     <h5 className="text-primary">{type}</h5>
     <h5 className="mb-0"> {name}</h5>
    </div>
    <div>
     <IconButton variant="primary" size="md" icon="envelope" iconClassName="me-sm-1" className="me-2">
      <span className="d-none d-sm-inline-block">Mensaje</span>
     </IconButton>
     <IconButton variant="falcon-default" size="md" icon="users" iconClassName="me-sm-1">
      <span className="d-none d-sm-inline-block">.</span>
     </IconButton>
    </div>
   </Card.Body>
  </Card>
 );
};

PageHeader.propTypes = {
 type: PropTypes.string.isRequired,
 name: PropTypes.string.isRequired
};

export default PageHeader;
